const v = "5.7.5";
const fr = 100;
const ip = 0;
const op = 100;
const w = 24;
const h = 24;
const nm = "Comp 1";
const ddd = 0;
const metadata = {
	backgroundColor: {
		r: 255,
		g: 255,
		b: 255
	}
};
const assets = [
];
const layers = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "Vector",
		sr: 1,
		ks: {
			p: {
				a: 0,
				k: [
					0,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0
				],
				ix: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100
				],
				ix: 2
			},
			r: {
				a: 0,
				k: 0,
				ix: 2
			},
			o: {
				a: 0,
				k: 100,
				ix: 2
			},
			sk: {
				a: 0,
				k: 0,
				ix: 2
			},
			sa: {
				a: 0,
				k: 0,
				ix: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				nm: "Vector",
				it: [
					{
						ty: "sh",
						d: 1,
						ks: {
							a: 1,
							k: [
								{
									t: 0,
									s: [
										{
											c: false,
											v: [
												[
													9.081846237182617,
													0
												],
												[
													4.540923118591309,
													4.540923118591309
												],
												[
													0,
													0
												]
											],
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											]
										}
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								},
								{
									t: 100,
									s: [
										{
											c: false,
											v: [
												[
													15,
													0
												],
												[
													7.5,
													7.5
												],
												[
													0,
													0
												]
											],
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											]
										}
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								}
							],
							ix: 2
						}
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.6196078431372549,
								0.6,
								0.6078431372549019
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 100,
							ix: 2
						},
						w: {
							a: 0,
							k: 1.5,
							ix: 2
						},
						lc: 2,
						lj: 2,
						ml: 4
					},
					{
						ty: "tr",
						p: {
							a: 1,
							k: [
								{
									t: 0,
									s: [
										14.959076881408691,
										6.770461559295654
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								},
								{
									t: 100,
									s: [
										9.040924072265625,
										10.25
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								}
							],
							ix: 2
						},
						a: {
							a: 1,
							k: [
								{
									t: 0,
									s: [
										7.5,
										3.75
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								},
								{
									t: 100,
									s: [
										4.540923118591309,
										2.2704615592956543
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								}
							],
							ix: 2
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 2
						},
						r: {
							a: 0,
							k: 0,
							ix: 2
						},
						o: {
							a: 1,
							k: [
								{
									t: 0,
									s: [
										0
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								},
								{
									t: 100,
									s: [
										100
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								}
							],
							ix: 2
						},
						sk: {
							a: 0,
							k: 0,
							ix: 2
						},
						sa: {
							a: 0,
							k: 0,
							ix: 2
						}
					}
				]
			}
		],
		ip: 0,
		op: 101,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "Vector",
		sr: 1,
		ks: {
			p: {
				a: 0,
				k: [
					0,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0
				],
				ix: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100
				],
				ix: 2
			},
			r: {
				a: 0,
				k: 0,
				ix: 2
			},
			o: {
				a: 0,
				k: 100,
				ix: 2
			},
			sk: {
				a: 0,
				k: 0,
				ix: 2
			},
			sa: {
				a: 0,
				k: 0,
				ix: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				nm: "Vector",
				it: [
					{
						ty: "sh",
						d: 1,
						ks: {
							a: 1,
							k: [
								{
									t: 0,
									s: [
										{
											c: false,
											v: [
												[
													15,
													0
												],
												[
													7.5,
													7.5
												],
												[
													0,
													0
												]
											],
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											]
										}
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								},
								{
									t: 100,
									s: [
										{
											c: false,
											v: [
												[
													10.990970611572266,
													0
												],
												[
													5.495485305786133,
													5.495485305786133
												],
												[
													0,
													0
												]
											],
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											]
										}
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								}
							],
							ix: 2
						}
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.6196078431372549,
								0.6,
								0.6078431372549019
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 100,
							ix: 2
						},
						w: {
							a: 0,
							k: 1.5,
							ix: 2
						},
						lc: 2,
						lj: 2,
						ml: 4
					},
					{
						ty: "tr",
						p: {
							a: 1,
							k: [
								{
									t: 0,
									s: [
										12,
										11.75
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								},
								{
									t: 100,
									s: [
										12,
										20.25225830078125
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								}
							],
							ix: 2
						},
						a: {
							a: 1,
							k: [
								{
									t: 0,
									s: [
										7.5,
										3.75
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								},
								{
									t: 100,
									s: [
										5.495485305786133,
										2.7477426528930664
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								}
							],
							ix: 2
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 2
						},
						r: {
							a: 0,
							k: 0,
							ix: 2
						},
						o: {
							a: 1,
							k: [
								{
									t: 0,
									s: [
										100
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								},
								{
									t: 100,
									s: [
										0
									],
									i: {
										x: [
											0.75
										],
										y: [
											0.75
										]
									},
									o: {
										x: [
											0.25
										],
										y: [
											0.25
										]
									}
								}
							],
							ix: 2
						},
						sk: {
							a: 0,
							k: 0,
							ix: 2
						},
						sa: {
							a: 0,
							k: 0,
							ix: 2
						}
					}
				]
			}
		],
		ip: 0,
		op: 101,
		st: 0,
		bm: 0
	}
];
const markers = [
];
const accountArrow = {
	v: v,
	fr: fr,
	ip: ip,
	op: op,
	w: w,
	h: h,
	nm: nm,
	ddd: ddd,
	metadata: metadata,
	assets: assets,
	layers: layers,
	markers: markers
};

export { assets, ddd, accountArrow as default, fr, h, ip, layers, markers, metadata, nm, op, v, w };
